export default {
      id: "oc-help-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-help",
      toString: function () {
        return this.url;
      }
    }